export const TOGGLE_SGZ_SPECIFIC_DETAIL_PANEL = 'TOGGLE_SGZ_SPECIFIC_DETAIL_PANEL'

export function displaySgzSpecificDetailPanelReducer (state = {value: false, streetId: ""}, action) {
    switch (action.type){
        case TOGGLE_SGZ_SPECIFIC_DETAIL_PANEL:
            return action.payload
        default: return state
    }
}
